import { ModelFileItem } from '@/types/mock-api-types'
import { Picture } from '@/types/schema/api/file'

const convertModelFileItemToPicture = (
  modelFileItem: ModelFileItem,
): Picture | undefined => {
  if (!modelFileItem.signedUrl || !modelFileItem.id || !modelFileItem.url) {
    return undefined
  }

  return {
    signed_url: modelFileItem.signedUrl,
    url: modelFileItem.url,
    uuid: modelFileItem.id,
  }
}

export default convertModelFileItemToPicture
